import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { TreasuryOdcPaymentModel } from '@app/shared/models/elements-table-odc-treasury.model';
import { DialogPayMentDetailModel } from '@app/shared/models/dialog-payment-detail.model';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { PaymentService } from '@app/modules/management/services/payment.service';
import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { GetDetailODCStringCommand } from '@app/modules/management/command/get-detail-odc-string.command';

const logger = new LoggerService('ModalDatailPayOdcComponent');

@Component({
  selector: 'dhl-modal-datail-pay-odc',
  templateUrl: './modal-datail-pay-odc.component.html',
  styleUrls: ['./modal-datail-pay-odc.component.scss']
})
export class ModalDatailPayOdcComponent implements OnInit {
  ELEMENT_DATA: TreasuryOdcPaymentModel[] = [];
  displayedColumns: string[] = ['position', 'name', 'weight', 'fix', 'fix2'];
  dataSource = new MatTableDataSource<TreasuryOdcPaymentModel>(this.ELEMENT_DATA);
  selection = new SelectionModel<TreasuryOdcPaymentModel>(true, []);
  dialogData: DialogPayMentDetailModel;
  srcData: TreasuryOdcPaymentModel[] = this.ELEMENT_DATA;

  ngOnInit(): void {
    const command: GetDetailODCStringCommand = {
      orderId: this.dialogData.OrderId
    };
    this.callServiceDetailOdc(command);
  }

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogPayMentDetailModel,
    private readonly authenticationService: AuthenticationService,
    public paymentservice: PaymentService) {
    this.dialogData = data;

  }

  // Servicio que trae los detalles de odc tesoreria
  callServiceDetailOdc(command: GetDetailODCStringCommand) {
    this.paymentservice.OdcPaymentDetail(command).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          logger.info('ok');
          for (const element of response.data) {
            this.ELEMENT_DATA.push({ orderId: element.orderId, pay: element.pay, paymentDate: element.paymentDate, totalToPay: element.totalToPay, amountPaid: element.amountPaid, balance: element.balance, reason: element.reason });
          }
          this.dataSource = new MatTableDataSource<TreasuryOdcPaymentModel>(this.ELEMENT_DATA);
        }
      },
      error: (e) => {
        logger.error(e);
        this.authenticationService.validateLogued(e);
      },
      complete: () => {
        // This is intentional
      }
    });
  }
  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
